var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7261 21.2617L41.063 16.166L43.9803 31.2438L17.6434 36.3395L14.7261 21.2617Z",
    fill: "#017A54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3096 31.7587L43.9715 31.2438L41.0561 16.1689L14.7241 21.2607L14.8931 22.1344L40.0349 19.5162L41.3096 31.7587Z",
    fill: "#017A54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3095 31.7591L40.0348 19.5166L14.8931 22.1348L17.6395 36.336L41.3095 31.7591Z",
    fill: "#016F4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7275 23.083L39.4131 20.2938L41.0099 35.5712L14.3244 38.3604L12.7275 23.083Z",
    fill: "#019F74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 35.8271V23.7607H12.792L14.3109 38.3522L38.5646 35.8271Z",
    fill: "#018C6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 24.4766H37.8485V39.8307H11.0288V24.4766Z",
    fill: "#4FD79C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3774 35.504C34.8072 35.5054 34.2607 35.7328 33.858 36.1365C33.4552 36.5402 33.229 37.0872 33.229 37.6575H15.6498C15.6498 37.3746 15.594 37.0945 15.4858 36.8332C15.3775 36.5719 15.2188 36.3345 15.0188 36.1345C14.8187 35.9345 14.5813 35.7759 14.3199 35.6678C14.0586 35.5596 13.7785 35.5039 13.4956 35.504V28.8016C13.7785 28.8016 14.0586 28.7459 14.32 28.6377C14.5813 28.5294 14.8188 28.3707 15.0188 28.1707C15.2189 27.9707 15.3775 27.7332 15.4858 27.4718C15.5941 27.2105 15.6498 26.9304 15.6498 26.6475H33.229C33.2288 27.2178 33.4549 27.765 33.8577 28.1689C34.2605 28.5727 34.8071 28.8003 35.3774 28.8016V35.504Z",
    fill: "#7CF4A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4378 35.3834C26.2224 35.3834 27.669 33.9367 27.669 32.1521C27.669 30.3676 26.2224 28.9209 24.4378 28.9209C22.6532 28.9209 21.2065 30.3676 21.2065 32.1521C21.2065 33.9367 22.6532 35.3834 24.4378 35.3834Z",
    fill: "#4FD79C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans1);
export default __webpack_public_path__ + "static/media/trans1.7b9097c5beca6245729d4b9602173fc7.svg";
export { ForwardRef as ReactComponent };